import { render } from "./SupplierImportModal.vue?vue&type=template&id=932a7ca0&scoped=true"
import script from "./SupplierImportModal.vue?vue&type=script&lang=js"
export * from "./SupplierImportModal.vue?vue&type=script&lang=js"

import "./SupplierImportModal.vue?vue&type=style&index=0&id=932a7ca0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-932a7ca0"]])

export default __exports__